import axios from 'axios'
import _get from 'lodash/get'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const RECEIVE_BANK_ACCOUNT = 'RECEIVE_BANK_ACCOUNT'
export const REQUEST_BANK_ACCOUNT = 'REQUEST_BANK_ACCOUNT'
export const SAVE_BANK_ACCOUNT = 'SAVE_BANK_ACCOUNT'
export const UPDATE_AND_SAVE_BANK_ACCOUNT = 'UPDATE_AND_SAVE_BANK_ACCOUNT'

export const requestBankAccount = () => (dispatch, getState) => {
    dispatch({ type: REQUEST_BANK_ACCOUNT })

    const { profile } = getState()

    const { id: userId } = profile

    axios
        .get(`/bankaccount/${userId}`)
        .then((response) => {
            const data = _get(response, ['data'], {})
            dispatch(receiveBankAccount({ ...data, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(receiveBankAccount({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveBankAccount({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

const receiveBankAccount = (data) => ({ type: RECEIVE_BANK_ACCOUNT, data })

export const updateAndSaveBankAccount = (data, options) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_BANK_ACCOUNT, data })

    dispatch(receiveBankAccount(data))
    return dispatch(saveBankAccount(options))
}

const saveBankAccount =
    ({ hideAlert } = {}) =>
    (dispatch, getState) => {
        dispatch({ type: SAVE_BANK_ACCOUNT })

        const { profile, bankAccount } = getState()

        const { id: userId } = profile

        return axios
            .put(`/bankaccount/${userId}`, { ...bankAccount, userId })
            .then((response) => {
                dispatch(receiveBankAccount(response.data))

                if (!hideAlert) {
                    dispatch(receiveSuccessAlert('Bank details updated'))
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }
